<div class="preview-lane-buttons" *ngIf="loaded">
  <button class="toggle-btn icon-button"
          id="preview-work-item-lane-button"
          [disabled]="isWorkLaneButtonClickDisabled"
          [ngClass]="{ 'toggle-btn-active': isWorkLaneVisible }"
          (click)="onWorkLaneButtonClick()">
    <div class="button-tooltip-wrapper">
      <svg-icon [icon]="'chat-outline'"></svg-icon>
      <ng2-tooltip class="button-tooltip" direction="bottom" text="{{ (isWorkLaneButtonClickDisabled ? 'previewLaneButtons.disabledButtonTooltip' : 'previewLaneButtons.workItem') | translate }}"></ng2-tooltip>
    </div>
  </button>

  <button class="toggle-btn icon-button"
          id="preview-info-lane-button"
          [disabled]="isInfoButtonClickDisabled"
          [ngClass]="{ 'toggle-btn-active': isInfoPanelVisible }"
          (click)="onInfoButtonClick()">
    <div class="button-tooltip-wrapper">
      <svg-icon [icon]="'info-outline'"></svg-icon>
      <ng2-tooltip class="button-tooltip" direction="bottom" text="{{ (isInfoButtonClickDisabled ? 'previewLaneButtons.disabledButtonTooltip' : 'tooltips.visitorInfo') | translate }}"></ng2-tooltip>
    </div>
  </button>
  <button class="toggle-btn icon-button"
          id="preview-visitor-history-lane-button"
          [disabled]="isVisitorHistoryButtonClickDisabled"
          [ngClass]="{ 'toggle-btn-active': isVisitorHistoryButtonVisible }"
          (click)="onVisitorHistoryButtonClick()">
    <div class="button-tooltip-wrapper">
      <svg-icon [icon]="'history-outline'"></svg-icon>
      <ng2-tooltip class="button-tooltip" direction="bottom" text="{{ (isVisitorHistoryButtonClickDisabled ? 'previewLaneButtons.disabledButtonTooltip' : 'tooltips.visitorHistory') | translate }}"></ng2-tooltip>
    </div>
  </button>
</div>
